export default {
	ENABLED: 0,
	MODIFIED: 1,
	SUBMITTING: 2,
	SUBMITTED: 3,
}
